export const SubTitle =
  'font-Roboto text-16 leading-18 border-machine2-75 border-b pb-4 uppercase text-black'
export const HelpTextWrapper = 'leading-24 whitespace-pre-line font-light'
export const ItemWrapper = 'group border-machine2-75 w-full border-b py-7'
export const ItemInfo = 'flex w-full flex-col mb-6 xl:flex-row xl:mb-0'
export const ItemColLeft =
  'flex w-full shrink-0 flex-col justify-between xl:w-[350px]'
export const ItemColRight = 'flex grow'
export const ItemTitleLink = 'mb-6 flex flex-row items-center'
export const ItemStatus = 'font-Roboto text-12 rounded p-1 text-white'
export const ItemTableWrapper = 'font-Roboto text-14 leading-20 mb-6 table'
export const ItemTableRow = 'table-row'
export const ItemTableCell = 'table-cell'
export const ItemTableCellLabel = `${ItemTableCell} font-bold`
export const ItemTableCellValue = `${ItemTableCell} text-right md:text-left`
export const ItemImageWrapper =
  'relative mr-[10px] aspect-square h-fit max-h-[120px] min-h-[60px] w-auto min-w-[60px] max-w-[120px] last-of-type:mr-0'
export const ItemImage = 'z-0 w-full'
export const ItemImageOverlayInfo =
  'z-1 font-Roboto text-20 sm:text-28 lg:text-36 bg-whiteTransparent absolute left-0 top-0 flex h-full w-full items-center justify-center text-black'
export const DetailsShippingInfo =
  'border-machine2-75 border-b border-t py-4 mb-12'
export const DetailShippingItem =
  'font-Roboto text-14 leading-24 font-bold border-r px-2 first:pl-0 last:border-none last:pr-0'
export const DetailColumnsWrapper =
  'flex w-ful flex-wrap flex-r max-xl:flex-col '
export const Detail2ColumnsWrapper =
  'flex flex-row flex-[0_0_50%] pb-6 max-sm:flex-col xl:mb-12'
export const DetailColumn = 'w-full xl:flex-[0_0_50%] mb-12 xl:mb-0'
export const DetailColumnText = 'flex font-Roboto text-14 leading-22'
export const DetailColumnLabel = `${DetailColumnText} font-bold mb-4`
export const ActionsWrapper =
  'font-Roboto text-14 leading-12 tracking-3 cursor-pointer uppercase group-hover:underline underline-offset-8'
